import { render, staticRenderFns } from "./ChangeAuthRequested.vue?vue&type=template&id=27c1e5b7"
import script from "./ChangeAuthRequested.vue?vue&type=script&lang=js"
export * from "./ChangeAuthRequested.vue?vue&type=script&lang=js"
import style0 from "./ChangeAuthRequested.vue?vue&type=style&index=0&id=27c1e5b7&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports